Wee.fn.make('currency', {
	init: function() {
		var $priv = this.$private,
			currency = $priv.getCookie('currency'),
			$currencySelectors = $('ref:swapCurrency'),
			activeClass = '-is-active';

		Wee.view.addHelper('numberFormat', function() {
			var value = this.val.toString();

			if (value.length === 6) {
				return '$' + value.slice(0, 3) + ',' + value.slice(3);
			} else if (value.length === 5) {
				return '$' + value.slice(0, 2) + ',' + value.slice(2);
			} else if (value.length === 4) {
				return '$' + value.slice(0, 1) + ',' + value.slice(1);
			} else if (parseInt(value) === 0) {
				return String.fromCharCode(160);
			} else {
				return '$' + value;
			}
		});

		if (currency) {
			switch (currency) {
				case 'usd':
					$currencySelectors.each(function(el) {
						var $el = $(el);

						if ($el.data('currency') === 'usd') {
							$el.addClass(activeClass);
						} else {
							$el.removeClass(activeClass);
						}
					});

					$priv.swapCurrency('usd');
					break;
				case 'can':
					$currencySelectors.each(function(el) {
						var $el = $(el);

						if ($el.data('currency') === 'can') {
							$el.addClass(activeClass);
						} else {
							$el.removeClass(activeClass);
						}
					});

					$priv.swapCurrency('can');
					break;
			}
		} else {
			$priv.swapCurrency('usd');
		}

		$priv.bind();
	}
}, {
	/**
	 * Binds various events related to currency swapping.
	 *
	 * @private
	 * @return void
	 */
	bind: function() {
		var scope = this;

		$('ref:swapCurrency').on('click', function(e, el) {
			var	currency = $(el).data('currency'),
				activeClass = '-is-active';

			$('ref:swapCurrency').filter('[data-currency="' + currency + '"]')
				.addClass(activeClass)
				.siblings()
				.removeClass(activeClass);

			scope.swapCurrency(currency);

			scope.setCookie(currency);
		});

		$('ref:productSection').on('productLoadComplete', function() {
			var currency = scope.getCookie();

			scope.swapCurrency(currency);
		});
	},

	/**
	 * Gets a cookie representing the user's preferred currency.
	 *
	 * @private
	 * @return cookie | The currency symbol
	 */
	getCookie: function() {
		var cookie = document.cookie.replace(/(?:(?:^|.*;\s*)currency\s*\=\s*([^;]*).*$)|^.*$/, '$1');

		if (! cookie) {
			document.cookie = 'currency=usd';

			cookie = 'usd';
		}

		return cookie;
	},

	/**
	 * Sets a cookie representing the user's preferred currency.
	 *
	 * @private
	 * @return void
	 */
	setCookie: function(currency) {
		document.cookie = 'currency=' + currency;
	},

	/**
	 * Swaps the currency denomination for any element that outputs currency.
	 *
	 * @private
	 * @param {string} currency | The currency symbol being swapped TO
	 * @return void
	 */
	swapCurrency: function(currency) {
		var $pricing = $.get('pricing'),
			entry,
			variants,
			params,
			productId;

		if ($.get('productDetail')) {
			variants = $pricing[$.get('productId')][currency],
			params = {
				standardPrice: variants.standard || 0,
				salePrice: parseInt(variants.sale) || 0,
				hasSale: $pricing[Object.keys($pricing)[0]].isSale
			};

			$('ref:priceOutput').html(Wee.view.render('priceOutput', params));
		} else if ($.get('cartTemplate')) {
			if ($pricing) {
				for (var i in $pricing) {
					if ($pricing.hasOwnProperty(i)) {
						variants = $pricing[i][currency];
						params = {
							standardPrice: (variants.standard || 0) * $pricing[i].itemQty,
							salePrice: (parseInt(variants.sale) || 0) * $pricing[i].itemQty,
							hasSale: $pricing[i].isSale
						};

						$('ref:priceOutput').filter('[data-entry-id="' + i + '"]')
							.html(Wee.view.render('priceOutput', params));
					}
				}
			}
		} else {
			for (entry in $pricing) {
				var $product = $('ref:' + entry);

				variants = $pricing[entry][currency],
				params = {
					standardPrice: variants.standard || 0,
					salePrice: parseInt(variants.sale) || 0,
					hasSale: $pricing[entry].isSale
				};

				$product.find('ref:priceOutput').html(Wee.view.render('priceOutput', params));
			}
		}
	}
});